import {
  createApiFactory,
  createComponentExtension,
  createPlugin,
  createRoutableExtension,
  discoveryApiRef,
  fetchApiRef,
} from '@backstage/core-plugin-api';

import { dxSetupApiRef } from './apis/DxSetupApi';
import { DxSetupClient } from './apis/DxSetupClient';
import { rootRouteRef } from './routes';

export const dxSetupPlugin = createPlugin({
  id: 'dx-setup',
  routes: {
    root: rootRouteRef,
  },
  apis: [
    createApiFactory({
      api: dxSetupApiRef,
      deps: {
        discoveryApi: discoveryApiRef,
        fetchApi: fetchApiRef,
      },
      factory: ({ discoveryApi, fetchApi }) =>
        DxSetupClient.create({ discoveryApi, fetchApi }),
    }),
  ],
});

export const DxSetupPage = dxSetupPlugin.provide(
  createRoutableExtension({
    name: 'DxSetupPage',
    component: () =>
      import('./components/DxSetupPage').then(m => m.DxSetupPage),
    mountPoint: rootRouteRef,
  }),
);

export const DxIcon = dxSetupPlugin.provide(
  createComponentExtension({
    name: 'DxIcon',
    component: {
      lazy: () => import('./components/DxIcon').then(m => m.DxIcon),
    },
  }),
);
